import { useHead } from '@vueuse/head'

// 默认的 meta 配置，从 index.html 获取
const DEFAULT_META = {
  title: 'dfans: No overbearing KYC procedures. - dfans.co',
  description:
    'dfans is a decentralized social platform that revolutionizes the way creators connect with fans, ensuring they never have to worry about identity verification, content censorship, or the payout process.',
}

export function useDfansHead(options?: {
  title?: string | (() => string)
  meta?: Array<{
    property?: string
    name?: string
    content: string | (() => string)
    key?: string
  }>
}) {
  // 如果没有传入配置，使用默认配置
  if (!options) {
    return useHead({
      title: DEFAULT_META.title,
      meta: [
        {
          name: 'description',
          content: DEFAULT_META.description,
        },
      ],
    })
  }

  const title = options.title
    ? typeof options.title === 'function'
      ? options.title()
      : options.title
    : DEFAULT_META.title

  // 构建 meta 数组
  const metaArray = []

  // 处理 description
  const descriptionMeta = options.meta?.find(item => item.name === 'description')
  metaArray.push({
    name: 'description',
    content:
      'dfans - ' +
      (descriptionMeta
        ? typeof descriptionMeta.content === 'function'
          ? descriptionMeta.content()
          : descriptionMeta.content
        : DEFAULT_META.description),
  })

  // 处理其他自定义 meta
  options.meta?.forEach(item => {
    if (item.name !== 'description') {
      metaArray.push({
        ...item,
        content: typeof item.content === 'function' ? item.content() : item.content,
      })
    }
  })

  return useHead({
    title,
    meta: [...metaArray],
  })
}
